import { render, staticRenderFns } from "./ColorPaletteList.vue?vue&type=template&id=fcbe42fe&scoped=true"
import script from "./ColorPaletteList.vue?vue&type=script&lang=js"
export * from "./ColorPaletteList.vue?vue&type=script&lang=js"
import style0 from "./ColorPaletteList.vue?vue&type=style&index=0&id=fcbe42fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbe42fe",
  null
  
)

export default component.exports